import React from 'react';
import { Bookmark, BookmarkActionHandlers } from './types';
import { formatDate } from './utils';
import { BookmarkActions } from './BookmarkActions';
import { BookmarkTags } from './BookmarkTags';

interface BookmarkListItemProps {
  bookmark: Bookmark;
  handlers: BookmarkActionHandlers;
  isGrouped?: boolean;
}

export const BookmarkListItem: React.FC<BookmarkListItemProps> = ({ 
  bookmark, 
  handlers,
  isGrouped = false 
}) => {
  const dateInfo = formatDate(bookmark.createdAt);

  return (
    <div className="bookmark-list-item">
      <div className="bookmark-list-main">
        <div className="bookmark-list-icon">
          {bookmark.favicon ? (
            <img 
              src={bookmark.favicon} 
              alt="" 
              className="bookmark-favicon"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          ) : (
            <div className="bookmark-favicon-placeholder">
              <span role="img" aria-label="website">🌐</span>
            </div>
          )}
        </div>
        <div className="bookmark-list-content">
          <div className="bookmark-list-header">
            <p className="bookmark-url">
              <a href={bookmark.url} target="_blank" rel="noopener noreferrer">
                {bookmark.url}
              </a>
            </p>
            <div className={`bookmark-date-info ${isGrouped ? 'grouped' : ''}`}>
              {isGrouped ? (
                <p className="bookmark-time">{dateInfo.timeStr}</p>
              ) : (
                <>
                  <p className="bookmark-date">{dateInfo.dateStr}</p>
                  <p className="bookmark-day">{dateInfo.dayStr}</p>
                  <p className="bookmark-time">{dateInfo.timeStr}</p>
                </>
              )}
            </div>
          </div>
          {bookmark.title && (
            <h3 className="bookmark-title">{bookmark.title}</h3>
          )}
          <p className="bookmark-description">{bookmark.description}</p>
          <BookmarkTags
            bookmarkId={bookmark.id}
            tags={bookmark.tags}
            onAddTag={handlers.onAddTag}
            onRemoveTag={handlers.onRemoveTag}
            onTagClick={handlers.onTagClick}
          />
        </div>
        <BookmarkActions
          bookmarkId={bookmark.id}
          url={bookmark.url}
          onDelete={handlers.onDelete}
          onOpenExternal={handlers.onOpenExternal}
          onAddToCollection={handlers.onAddToCollection}
          onToggleFavorite={handlers.onToggleFavorite}
          variant="list"
        />
      </div>
    </div>
  );
};